/**
 * Show current user username and its id replacing the provided tag
 */
export default function fmUsername($rootScope, UsersService) {
  'ngInject';
  return {
    restrict: 'E',
    replace: true,
    template: '<span class="username">{{user.name}} <abbr ng-if="user.id">{{user.id}}</abbr></span>',
    link: function (scope, element, attrs) {
      let assignToScope = (user) => {
        scope.user = user ? {name: user.nome, id: user.id_user} : {name: 'Accedi'};
      };
      // used when storage change its value
      let eventListener = ($event, payload) => {
        if (payload.key !== 'currentUser') return;
        assignToScope(UsersService.currentUser());
      };
      // initially load user
      assignToScope(UsersService.currentUser());
      // configure listeners on storage events
      $rootScope.$on('LocalStorageModule.notification.setitem', eventListener);
      $rootScope.$on('LocalStorageModule.notification.removeitem', eventListener);
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/directives/username.js